import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { Provider } from 'react-redux';
import Map from './components/Map';
import { getElementAttribute, getPaths, getReactElement } from './utils/element';
import { setApiPathsPlugin } from './api/api';
import { currentLang } from '../../utils/lang';
import { basePath } from '../../utils/router';
import { store } from './store/store';
import Modal from './components/Modal';
const hasTranslationOriginQuery = new URLSearchParams(window.location.search).get('show-trans-origin') === 'true';
i18n.use({
    type: 'postProcessor',
    name: 'addTranslationDebugPrefix',
    process: (value) => (hasTranslationOriginQuery ? `t:${value}` : value),
});
i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: require('@/translations/store_locator.en.json'),
        },
        et: {
            translation: require('@/translations/store_locator.et.json'),
        },
        ru: {
            translation: require('@/translations/store_locator.ru.json'),
        },
    },
    lng: currentLang(),
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
        prefix: '%',
        suffix: '%',
    },
    postProcess: ['addTranslationDebugPrefix'],
});
ReactGA.initialize([
    {
        trackingId: getElementAttribute('data-google-tag-manager-id'),
    },
]);
export default function app() {
    const reactElement = getReactElement();
    const root = createRoot(reactElement);
    setApiPathsPlugin(getPaths());
    root.render(_jsx(Provider, { store: store, children: _jsxs(BrowserRouter, { basename: basePath(reactElement), children: [_jsx(Map, {}), _jsx(Modal, {})] }) }));
}
